// Step-by-step softphone guide (/parametres/telephone). Field names in quotes are the
// literal English labels shown by MicroSIP / Zoiper.
export const softphoneGuideFr = {
  title: "Guide d'installation pas à pas",
  intro:
    "Suis les étapes dans l'ordre. Les valeurs à taper sont personnalisées pour toi : clique « Copier » puis colle-les dans le softphone.",
  tabs_label: "Ton ordinateur",
  tab_windows: "Windows",
  tab_mac: "Mac",
  detected_windows:
    "Nous avons détecté Windows. Si ce n'est pas ton ordinateur, change d'onglet.",
  detected_mac:
    "Nous avons détecté un Mac. Si ce n'est pas ton ordinateur, change d'onglet.",
  step: "Étape %{n}",
  loading: "Chargement de ton profil…",
  no_subaccount:
    "Ton administrateur n'a pas encore associé de sous-compte VoIP.ms à ton profil. Demande-lui de le faire, puis reviens sur cette page pour continuer.",
  your_subaccount: "Ton sous-compte VoIP.ms : %{subaccount}",
  password_title: "Ton mot de passe SIP",
  password:
    "Le CRM ne conserve pas ton mot de passe SIP. Demande ton mot de passe SIP à ton administrateur (il le trouve dans le portail VoIP.ms → Sub Accounts → Manage Sub Accounts → crayon sur ton sous-compte). Ne le partage jamais par courriel non chiffré ; un message Teams privé convient.",
  copy: "Copier",
  copy_label: "Copier %{label}",
  copied: "%{label} copié.",
  copy_failed: "Copie impossible : sélectionne le texte et copie-le à la main.",
  field: "Champ",
  value: "Valeur à entrer",
  empty: "(laisser vide)",
  password_value: "Ton mot de passe SIP (demandé à ton administrateur)",
  windows: {
    s1_title: "Télécharger et installer",
    s1_a: "Ouvre la page de téléchargement officielle :",
    s1_b: "Choisis la version « MicroSIP » normale (pas « Lite »).",
    s1_c: "Ouvre le fichier téléchargé, puis clique « Suivant » jusqu'à « Terminer ».",
    s2_title: "Ajouter ton compte",
    s2_a: "Ouvre MicroSIP.",
    s2_b: "Ouvre le menu : la petite flèche ▼ / « Menu » en haut à droite de MicroSIP, OU un clic droit sur l’icône MicroSIP près de l’horloge Windows. Choisis « Add Account » (ou « Account »).",
    s3_title: "Remplir la fiche du compte",
    s3_a: "Remplis chaque champ exactement comme dans le tableau. Utilise « Copier » pour éviter les fautes de frappe.",
    s3_b: "Laisse tous les autres champs à leur valeur par défaut, puis clique « Save ».",
    s4_title: "Vérifier la connexion",
    s4_a: "En bas de la fenêtre de MicroSIP, tu dois voir « Online » en vert.",
    s4_b: "Puis compose 4443 (test audio de VoIP.ms) : tu dois entendre un message et ta voix en écho. Sinon, ouvre la section « Dépannage » plus bas sur cette page.",
    s5_title: "Laisser le softphone ouvrir les liens d'appel",
    s5_a: "Ouvre le même menu (flèche ▼ ou clic droit sur l’icône près de l’horloge) → « Settings ».",
    s5_b: "Si tu vois une option pour les liens « sip: » / « tel: » / « callto: », coche-la et clique « Save ». Si tu ne la trouves pas, ce n’est pas grave : l’étape suivante (Windows) fait la même chose.",
    s5_c: "Si une option demande une confirmation avant chaque appel, décoche-la.",
    s5_d: "Clique « Save ».",
    s6_title: "Choisir l'application par défaut dans Windows",
    s6_a: "Ouvre Paramètres Windows → Applications → Applications par défaut, puis « Choisir les applications par défaut par type de lien » (Windows 11 : tape « SIP » dans la recherche de cette page).",
    s6_b: "Dans la recherche, tape « SIP » et choisis MicroSIP.",
    s6_c: "Recommence avec « TEL » et choisis MicroSIP.",
    s7_title: "Brancher ton casque",
    s7_a: "Branche ton casque, puis ouvre le menu MicroSIP (flèche ▼ ou clic droit sur l’icône près de l’horloge) → « Settings ».",
    s7_b: "Pour « Microphone » et « Speakers », choisis ton casque. Dans la même fenêtre (réglages recommandés par VoIP.ms) : codecs = G.711u (PCMU) seulement (retire les autres), « Source port » = 5060, « RTP ports » = 10001 à 20000, « EC » (annulation d’écho) coché. Clique « Save ».",
  },
  mac: {
    s1_title: "Télécharger et installer",
    s1_a: "Ouvre la page de téléchargement officielle :",
    s1_b: "Choisis « Zoiper 5 for macOS » (version gratuite).",
    s1_c: "Ouvre le fichier téléchargé et glisse l'icône dans le dossier Applications.",
    s1_d: "Ouvre l'application. Quand macOS demande l'accès au micro, clique « Autoriser ».",
    s2_title: "Te connecter",
    s2_a: "Sur l'écran de connexion, remplis les deux champs ci-dessous, puis clique « Login ».",
    s2_b: "Si l'application demande un « Hostname », colle le serveur indiqué dans le tableau.",
    s2_c: "Passe (« Skip ») les écrans de proxy et d'« outbound authentication ».",
    s2_d: "Quand l'application teste les protocoles, choisis « SIP UDP ».",
    s3_title: "Vérifier la connexion",
    s3_a: "Tu dois voir un point vert « Registered » à côté de ton compte.",
    s3_b: "Puis compose 4443 (test audio de VoIP.ms) : tu dois entendre un message et ta voix en écho. Sinon, ouvre la section « Dépannage » plus bas sur cette page.",
    s4_title: "Laisser le softphone ouvrir les liens d'appel",
    s4_a: "Ouvre Settings → General et coche « Handle tel: / sip: links ».",
    s4_b: "Si l'option n'y est pas : Settings → Integrations → « Register as default handler ».",
    s4_c: "Si macOS demande quelle application doit ouvrir les liens « sip: », choisis Zoiper.",
    s5_title: "Brancher ton casque",
    s5_a: "Ouvre Settings → Audio et choisis ton casque pour le micro et le haut-parleur. Puis Settings → Accounts → ton compte → Audio codecs : garde seulement « u-law » (G.711u).",
  },
  crm: {
    title: "Tester dans le CRM",
    a: "Descends à la section « Tester » de cette page et clique le bouton de test.",
    b: "Ton softphone doit s'ouvrir avec le numéro de test. Si tu entends l'appel, clique le bouton de confirmation.",
    c: "Pour travailler ensuite : menu Appeler → « Commencer à appeler » → « Composer ».",
  },
  test_section: "Tester",
  trouble: {
    title: "Dépannage",
    offline_q: "« Offline » ou « Registration failed »",
    offline_a:
      "Vérifie l'usager (%{username}), le mot de passe et le serveur (%{server}) : un seul caractère de trop suffit à bloquer. Vérifie aussi ta connexion Internet (un Wi-Fi invité ou un VPN peut bloquer la téléphonie). « Request Timeout » : mets « Source port » = 5060 dans les réglages ; si ça persiste, change le « Transport » du compte pour TCP.",
    forbidden_q: "« 403 Forbidden »",
    forbidden_a:
      "Le mot de passe SIP est mauvais. Redemande-le à ton administrateur et colle-le sans espace au début ni à la fin.",
    nothing_q: "« Composer » n'ouvre rien",
    nothing_a:
      "Refais l'étape des liens « sip: » / « tel: » et celle de l'application par défaut. Si rien ne change, choisis le type de lien « tel: » dans la section « Tester » ci-dessous, puis refais le test.",
    browser_q: "Le navigateur demande quelle application ouvrir",
    browser_a:
      "Choisis ton softphone (MicroSIP ou Zoiper) et coche « Toujours » pour ne plus avoir la question.",
    mute_q: "On ne m'entend pas",
    mute_a:
      "Choisis le micro du casque dans les réglages audio du softphone. Sur Mac, vérifie aussi la permission : Réglages Système → Confidentialité et sécurité → Micro → active Zoiper.",
    callerid_q: "Le client voit un autre numéro",
    callerid_a:
      "C'est le numéro affiché (CallerID) de ton sous-compte. Ton administrateur le règle dans VoIP.ms.",
    refused_q:
      "L'appel échoue : « Service Unavailable », « Busy Here » ou « Declined »",
    refused_a:
      "Le serveur doit être exactement %{server} (ton sous-compte n'est autorisé que sur ce serveur), le codec doit être G.711u (PCMU) seulement, et « Source port » = 5060. Fais le test 4443 après chaque changement. Si ça échoue encore, préviens ton administrateur.",
  },
  checklist: {
    title: "Liste de vérification finale",
    installed: "Le softphone est installé.",
    online: "Mon compte est en ligne (« Online » ou « Registered », en vert).",
    links: "Le softphone ouvre les liens « sip: » et « tel: ».",
    headset: "Mon casque est choisi pour le micro et le haut-parleur.",
    tested: "Le test d'appel a ouvert le softphone et j'ai entendu l'appel.",
    path: "Je sais où appeler : Appeler → Commencer à appeler → Composer.",
  },
  admin: {
    title: "Sous-comptes de l'équipe (admin)",
    intro:
      "Envoie à chaque représentant son sous-compte et son mot de passe SIP par message Teams privé.",
    name: "Représentant",
    subaccount: "Sous-compte VoIP.ms",
    can_dial: "Peut appeler",
    yes: "Oui",
    no: "Non",
    none: "Non associé",
    empty: "Aucun utilisateur.",
    error: "Impossible de charger l'équipe.",
  },
};
